import copy from "copy-text-to-clipboard";
import { CopyIcon } from "./Icons/CopyIcon";
import styles from "@/styles/CopyText.module.scss";
import { CheckSuccessIcon } from "./Icons/CheckSuccessIcon";
import { useEffect, useRef, useState } from "react";

export const CopyText = ({ text }: { text: string }) => {
	const [showSuccess, setShowSuccess] = useState<boolean>(false);
	const textareaRef = useRef<HTMLTextAreaElement>(null);

	useEffect(() => {
		if (textareaRef.current) {
			textareaRef.current.style.height = "auto"; // Reset height
			textareaRef.current.style.height = textareaRef.current.scrollHeight + "px"; // Set to scroll height
		}
	}, [text]);

	const handleCopy = (e: any) => {
		e.preventDefault();
		const copySuccess = copy(text);

		if (copySuccess) {
			setShowSuccess(true);
			setTimeout(() => {
				setShowSuccess(false);
			}, 5000);
		}
	};
	return (
		<form onSubmit={handleCopy} className={`flex ${styles.copyForm}`}>
			<textarea readOnly value={text} className={styles.copyField} ref={textareaRef} />
			{!showSuccess && (
				<button name="Hashtag kopieren" className={styles.copyButton}>
					<CopyIcon />
				</button>
			)}
			{showSuccess && (
				<div className={styles.copyButton}>
					<CheckSuccessIcon />
				</div>
			)}
		</form>
	);
};
